import { render, staticRenderFns } from "./HeaderContent.vue?vue&type=template&id=60b67b1a&scoped=true&"
import script from "./HeaderContent.vue?vue&type=script&lang=js&"
export * from "./HeaderContent.vue?vue&type=script&lang=js&"
import style0 from "./HeaderContent.vue?vue&type=style&index=0&id=60b67b1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b67b1a",
  null
  
)

export default component.exports